import { render, staticRenderFns } from "./yqqj.vue?vue&type=template&id=0b9783bb&scoped=true&"
import script from "./yqqj.vue?vue&type=script&lang=js&"
export * from "./yqqj.vue?vue&type=script&lang=js&"
import style0 from "./yqqj.vue?vue&type=style&index=0&id=0b9783bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9783bb",
  null
  
)

export default component.exports